import React, { useState } from "react";

// Material UI
import Button from "@mui/material/Button";
import DeleteIcon from "@mui/icons-material/Delete";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";

import DialogTitle from "@mui/material/DialogTitle";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Paper from "@mui/material/Paper";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";

// import Pagination from "@mui/material/Pagination";
// import Stack from "@mui/material/Stack";
// import DialogContentText from "@mui/material/DialogContentText";
// import InputLabel from "@mui/material/InputLabel";
// import MenuItem from "@mui/material/MenuItem";
// import FormControl from "@mui/material/FormControl";
// import Select from "@mui/material/Select";

// Redux
import { useSelector } from "react-redux";
import { selectToken } from "../../storeConfig/reducers/loginReducer";

// Router, React Query
import { Link } from "react-router-dom";
import {
	useGetUsersAdmin,
	deleteUser,
	deactivateUser,
} from "../../services/admin";
import { useQueryClient } from "@tanstack/react-query";
import { Container } from "@mui/material";

function ListarUsuarios() {
	const token = useSelector(selectToken);
	const [open, setOpen] = useState(false);

	// const [org, setOrg] = useState("");

	const queryClient = useQueryClient();
	const { isLoading, data } = useGetUsersAdmin(token);

	// const [page, setPage] = React.useState(1);

	// const handlePageChange = (event, value) => {
	// 	setPage(value);
	// };

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	const desativarUsuario = (id) => {
		deactivateUser(token, id)
			.then(function (r) {
				queryClient.invalidateQueries(["get-users-admin"]);
				handleClose();
			})
			.catch(function (e) {
				console.log(e);
			});
	};

	const deletarUsuario = (id) => {
		deleteUser(token, id)
			.then(function (r) {
				queryClient.invalidateQueries(["get-users-admin"]);
				handleClose();
			})
			.catch(function (error) {
				console.log(error);
			});
	};

	return (
		<div className="row d-flex justify-content-center mt-5">
			<div className="col-sm-10">
				<h2>Lista de Usuários Cadastrados</h2>

				{/* {!isLoading && (
					<FormControl
						variant="standard"
						sx={{ m: 1, minWidth: 500 }}
					>
						<InputLabel>Organização</InputLabel>
						<Select
							value={org}
							onChange={(e) => setOrg(e.target.value)}
							label="Organização"
						>
							{data.map((item, index) => {
								return (
									<MenuItem value={item.organizacao} key={index}>
										{item.organizacao.nome_organizacao}
									</MenuItem>
								);
							})} 
						</Select>
					</FormControl>
				)} */}

				<hr />

				{!isLoading &&
					data.map((item, index) => {
						let str = "";
						if (item.usuario_admin) str = "Usuário Administrador";
						else if (item.permissao_cadastrar)
							str = "Usuário Gestor";
						else str = "Usuário";

						return (
							<Paper key={index}>
								<Accordion
									className="mt-2"
									TransitionProps={{
										unmountOnExit: true,
									}}
								>
									<AccordionSummary
										expandIcon={<ExpandMoreIcon />}
										aria-controls="panel1a-content"
										id="panel1a-header"
									>
										<Typography>{item.email}</Typography>
									</AccordionSummary>
									<AccordionDetails>
										<div className="row">
											<div className="col-sm-4">
												<Typography>
													Nome do Usuário
												</Typography>
												{item.username ? (
													<p>{item.username}</p>
												) : (
													<p>Não cadastrado</p>
												)}
											</div>
											<div className="col-sm-4">
												<Typography>E-mail</Typography>
												<p>{item.email}</p>
											</div>
											<div className="col-sm-4">
												<Typography>Status</Typography>
												{item.is_active ? (
													<p>Ativo</p>
												) : (
													<p>Desativado</p>
												)}
											</div>
										</div>
										<div className="row mt-2">
											<div className="col-sm-4">
												<Typography>
													Organização
												</Typography>
												{item.organizacao ? (
													<p>
														{
															item.organizacao
																.nome_organizacao
														}
													</p>
												) : (
													<p>Não cadastrado</p>
												)}
											</div>
											<div className="col-sm-4">
												<Typography>Tipo</Typography>
												<p>{str}</p>
											</div>
										</div>

										<div className="row">
											<Typography>Resultados</Typography>

											<List
												sx={{
													bgcolor: "background.paper",
												}}
												component="nav"
											>
												{item.resultados.length !==
												0 ? (
													item.resultados.map(
														(it, ind) => {
															let data_resultado =
																new Date(
																	it.data_resultado
																);

															let dataResultado =
																data_resultado.toLocaleDateString(
																	"pt-BR"
																);
															let horaResultado =
																data_resultado.toLocaleTimeString(
																	"pt-BR"
																);

															return (
																<div key={ind}>
																	<Link
																		to={`resultado/${it.id}`}
																		className="text-decoration-none text-dark"
																	>
																		<ListItem
																			button
																			divider
																		>
																			<ListItemText
																				primary={
																					it.nome_organizacao ===
																					""
																						? `${dataResultado} ${horaResultado}`
																						: it.nome_organizacao
																				}
																				secondary={
																					it.nome_organizacao !==
																					""
																						? `${dataResultado} | ${horaResultado}`
																						: ""
																				}
																			/>
																		</ListItem>
																	</Link>
																</div>
															);
														}
													)
												) : (
													<ListItem button divider>
														<ListItemText primary="Nenhum" />
													</ListItem>
												)}
											</List>
										</div>

										<Button
											onClick={() => handleClickOpen()}
											className="mt-4 m-2"
											variant="contained"
											endIcon={<DeleteIcon />}
											size="small"
										>
											Deletar Usuário
										</Button>
										<Button
											onClick={() =>
												desativarUsuario(item.id)
											}
											className="mt-4 m-2"
											variant="outlined"
											size="small"
										>
											{item.is_active
												? "Desativar Usuário"
												: "Ativar Usuário"}
										</Button>

										<Dialog
											open={open}
											onClose={handleClose}
										>
											<DialogTitle>
												Excluir Usuário
											</DialogTitle>
											<DialogContent>
												<Container>
													<Typography component={"p"}>
														Tem certeza que deseja
														excluir o usuário?
													</Typography>
													<Typography
														component={"p"}
														className="text-center fw-bold"
													>
														{item.username
															? item.username
															: item.email}
													</Typography>
												</Container>
											</DialogContent>
											<DialogActions>
												<Button onClick={handleClose}>
													Não
												</Button>
												<Button
													onClick={() =>
														deletarUsuario(item.id)
													}
													autoFocus
												>
													Sim
												</Button>
											</DialogActions>
										</Dialog>
									</AccordionDetails>
								</Accordion>
							</Paper>
						);
					})}
			</div>

			{/* <div className="col-sm-10 d-flex justify-content-center mt-5">
				<Stack spacing={2}>
					<Pagination
						count={10}
						page={page}
						onChange={handlePageChange}
					/>
				</Stack>
			</div> */}
		</div>
	);
}

export default ListarUsuarios;
